import { ApplicationsTableQuery } from "./components/ApplicationsTableView/utils/applicationsTableQuery";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ApplicationLiteModel } from "../../viewModels/Applications/ApplicationModel";
import { ApplicationsFiltersType } from "../../components/V2Components/ApplicationFilters";
import SortObject from "../../types/SortObject";

const pageSizeLsKey = "applications_table_pageSize";
const pageSizeFromLs = localStorage.getItem(pageSizeLsKey);

const initialState: {
  loading: boolean;
  loadingData: boolean;
  exportLoading: boolean;
  error: boolean;
  page: number;
  pageSize: number;
  sort?: SortObject;
  applications?: Array<ApplicationLiteModel>;
  total?: number;
  filters?: ApplicationsFiltersType;
} = {
  loading: true,
  loadingData: true,
  exportLoading: false,
  error: false,

  page: undefined!,
  pageSize: pageSizeFromLs ? +pageSizeFromLs : 10,
};

const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {
    loadApplications(state, action: PayloadAction<ApplicationsTableQuery>) {
      state.error = false;
      state.loadingData = true;
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize || 10;
      state.filters = action.payload.filters;
      state.sort = action.payload.sort;
    },

    loadApplicationsSuccess(state, action: PayloadAction<{ applications?: Array<ApplicationLiteModel>; total: number }>) {
      const { applications, total } = action.payload;

      state.loading = false;
      state.loadingData = false;
      state.applications = applications;
      state.error = false;
      state.total = total;
    },
    loadApplicationsReject(state) {
      state.loading = false;
      state.loadingData = false;
      state.error = true;
    },

    updateApplication(state, _action: PayloadAction<ApplicationLiteModel>) {
      state.loadingData = true;
    },
    updateApplicationSuccess(state, action: PayloadAction<ApplicationLiteModel>) {
      state.loadingData = false;
      const index = state.applications?.findIndex((x) => x.id === action.payload.id);
      if (index !== undefined && index !== -1 && state.applications) {
        state.applications[index] = action.payload;
      }
    },

    deleteApplication(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },

    copyApplication(state, _action: PayloadAction<{ id: number; transportCharacteristicId: number }>) {
      state.loadingData = true;
    },

    exportApplications(state) {
      state.exportLoading = true;
    },
    exportApplicationsSuccess(state) {
      state.exportLoading = false;
    },
    exportApplicationsReject(state) {
      state.exportLoading = false;
    },

    resetState: () => initialState,
  },
});

export default applicationsSlice;
